import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { CallbackComponent } from 'redux-oidc';

import { setIsLogged } from './actionsCreator';

import userManager from '../../utils/userManager';

class LoginCallback extends React.Component {
  render() {
    const { t } = this.props;
    return (
      <CallbackComponent
        userManager={userManager}
        successCallback={(/*user*/) => {
          const { history, setIsLogged } = this.props;
          // const redirectUrl = user.state ? user.state.path : '/';
          setIsLogged();
          history.push('/contract');
          // history.push(redirectUrl);
        }}
        errorCallback={() => {
          this.props.history.push('/');
        }}
      >
      <div className='redirect-page'>
        <div className='redirect-container'>
          <div>{t('login.redirect')}</div>
          <div className='redirect-bar'></div>
        </div>
      </div>
      </CallbackComponent>
    );
  }
}

LoginCallback.propTypes = {
  history: PropTypes.object,
  setIsLogged: PropTypes.func,
  t: PropTypes.func
};

const mapStateToProps = () => {
  return {};
};

const mapDispatchToProps = {
  setIsLogged
};

const connectedLoginCallback = connect(mapStateToProps, mapDispatchToProps)(LoginCallback);
export { connectedLoginCallback as LoginCallback };
